module.exports = __webpack_public_path__ + "static/community-3-8c7c79e02ddc5a6cc25293568ffcfb37.png";